<template>
    <div class="table-list">
        <!-- <div class="c_m_b_btn" v-if="is_btn">
            <div class="c_m_b_btn_left">
                <slot name="btn_left"></slot>
            </div>
            <div class="c_m_b_btn_right">
                <slot name="btn_right"></slot>
                <a-dropdown v-model:visible="visibleDropdown" :getPopupContainer="getPopupContainer">
                    <img class="menu_img" src="@/assets/images/searchTable/menu.png" alt="">
                    <template #overlay>
                        <a-checkbox-group v-model:value="selectColumns">
                            <div class="menu_box_columns">
                                <div class="m_b_c_overflow">
                                    <div class="m_b_c_box" :key="item.key" v-for="(item) in columns">
                                        <a-checkbox :value="item.key">
                                            <div class="m_b_c_b_title" :title="item.title">{{item.title}}</div>
                                        </a-checkbox>
                                    </div>
                                </div>
                            </div>
                        </a-checkbox-group>
                    </template>
                </a-dropdown>
            </div>
        </div> -->
        <a-table @expandedRowsChange="expandedRowsChange" :expandedRowKeys="expandedRowKeys" :size="size"
            :bordered="bordered" :defaultExpandAllRows="defaultExpandAllRows" :columns="columns" :data-source="data"
            @change="paginchange" :loading="loading" :scroll="scroll" :pagination="pagination"
            :rowSelection="rowSelection">
            <template #headerCell="{ title, column }">
                <!-- 自定义表头 -->
                <slot :name="column.dataIndex + '_head'" :column="column" :title="title">
                </slot>
            </template>
            <template #bodyCell="{ column, record,index }">
                <template v-if="column.dataIndex == 'serial_num'">
                    <span>{{getSerialNum(index)}}</span>
                </template>
                <!-- 自定义表格内容 -->
                <slot :name="column.dataIndex" :record="record">
                </slot>
            </template>
            <template #emptyText>
                <slot name="emptyText">
                    <a-empty :image="simpleImage"></a-empty>
                </slot>
            </template>
            <template #summary>
                <slot name="summary" :data_count="data_count"></slot>
            </template>
        </a-table>
        <div class="zw_more" v-if="!isPage"></div>
        <div class="more_oper" :class="{ more_bottom: !isPage }" v-if="selectedRowKeys.length || is_all">
            <div class="check_box_a">
                <a-checkbox @change="allChange" v-model:checked="is_all_flag" v-if="is_all">全选</a-checkbox>
            </div>
            <slot name="selectAll" v-if="selectedRowKeys.length || is_all_flag"></slot>
        </div>
    </div>
</template>

<script>
    import {
        Empty
    } from 'ant-design-vue';
    export default {
        props: {
            firstFlag: { //是否渲染完就请求函数
                type: Boolean,
                default: true
            },
            search_form: { // 筛选条件
                type: Object,
                default: {}
            },
            api: { //请求方法
                type: Function,
                default: () => {
                    return new Promise((resolve, reject) => {
                        reject()
                    })
                }
            },
            size: { // 表格大小
                type: String,
                default: 'default'
            },
            columns: { // 表头
                type: Object,
                default: {}
            },
            showSizeChanger: { //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                type: Boolean,
                default: true
            },
            showQuickJumper: { // 是否可以快速跳转至某页
                type: Boolean,
                default: true
            },
            showTotal: {
                type: Function,
                default: (total, range) => {
                    return `共${total}条记录，每页${range}条`
                },
            },
            loadingFlag: { // 请求数据时是否在表格显示加载
                type: Boolean,
                default: true
            },
            scroll: {
                type: Object,
                default: {
                    x: 'max-content'
                }
            },
            select: { //是否可选择
                type: Boolean,
                default: false
            },
            selectType: { // 多选或者单选 radio
                type: String,
                default: 'checkbox'
            },
            selectKey: { //指定table每行的 key
                type: String,
                default: 'id'
            },
            isPage: { // 是否分页
                type: Boolean,
                default: true
            },
            defaultExpandAllRows: { // 是否默认展开
                type: Boolean,
                default: false
            },
            getCheckboxProps: { // 可勾选时是否禁止选中部分
                type: Function,
                default: record => ({})
            },
            all: { // 在渠道后台o2o商品那边有个全选然后需要通过这个值给它默认放上去
                type: Boolean,
                default: false
            },
            maxNum: { // 最大选择数量
                type: Number,
                default: -1
            },
            bordered: { // 表格边框
                type: Boolean,
                default: false
            },
            scrolFlag: { // 是否滚动加载数据
                type: Boolean,
                default: false
            },
            is_all: { // 是否有全选功能
                type: Boolean,
                default: false
            },
            is_btn: { // 是否有按钮
                type: Boolean,
                default: true
            }
            // class: {
            //     type: String,
            //         default: ''
            // }
        },
        data() {
            return {
                data: [],
                loading: false,
                pageInfo: {
                    pageSize: 10
                },
                selectedRowKeys: [], //所选id
                selectedRows: [], //所选数据项
                expandedRowKeys: [], //默认展开的行
                selectIs: null,
                where: {},
                simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
                lastScrollTop: 0,
                is_all_flag: false,
                visibleDropdown: true,
                selectColumns: [],
                data_count:{}
            }
        },
        mounted() {
            if (this.firstFlag) {
                this.getList()
            }
            if (this.scrolFlag) {
                this.$nextTick(() => {
                    const tableContainer = document.querySelector('.' + this.class).querySelector(
                        '.ant-table-body');
                    tableContainer.addEventListener('scroll', this.handleScroll)
                })
            }

        },
        watch: {
            all(val) {
                if (val) {
                    this.data.forEach(item => {
                        if (!this.selectedRowKeys.includes(item.key)) {
                            this.selectedRowKeys.push(item.key)
                        }
                    })
                }
            }
        },
        computed: {
            rowSelection() {
                if (!this.select) {
                    return null
                }
                return {
                    type: this.selectType,
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: this.selectChange,
                    fixed: true,
                    getCheckboxProps: this.getCheckboxProps,
                    preserveSelectedRowKeys: true
                }
            },
            pagination() {
                if (!this.isPage) {
                    return false
                }
                return {
                    showSizeChanger: this.showSizeChanger,
                    showQuickJumper: this.showQuickJumper,
                    showTotal: (total) => this.showTotal(total, this.pageInfo.pageSize),
                    pageSizeOptions: ['10', '15', '35', '50', '100'],
                    ...this.pageInfo
                }
            }
        },
        methods: {
            // 清空选择框
            closeSelectKeys() {
                this.selectIs = null
                this.selectedRowKeys = [] //所选id
                this.selectedRows = [] //所选数据项
                this.$emit('selectRow', {
                    ids: [],
                    data: []
                })
                this.is_all_flag = false
            },
            // 展开收起
            expandedRowsChange(e) {
                this.expandedRowKeys = e
            },
            // 处理级联数据
            handlerFun(arr) {
                arr.forEach(item => {
                    item.key = item.id
                    this.expandedRowKeys.push(item.id)
                    if (item.children && item.children.length) {
                        this.handlerFun(item.children)
                    }
                })
            },
            getList(page = 1) {
                if (this.loadingFlag) {
                    this.loading = true
                }
                this.api({
                    data: {
                        ...this.search_form,
                        page: this.isPage || this.scrolFlag ? page : null,
                        pageSize: this.isPage || this.scrolFlag ? this.pageInfo.pageSize : null,
                        ...this.where
                    },
                    loading: false
                }).then(res => {

                    if (this.isPage || this.scrolFlag) {
                        res.list.data.forEach(item => {
                            item.key = item[this.selectKey]
                            if (this.all) {
                                if (!this.selectedRowKeys.includes(item.key)) {
                                    this.selectedRowKeys.push(item.key)
                                }
                            }
                        })
                        this.pageInfo = {
                            current: res.list.current_page,
                            total: res.list.total,
                            pageSize: res.list.per_page,
                        }
                        if (this.scrolFlag) {
                            if (this.data.length == this.pageInfo.total) {
                                this.loading = false
                                return
                            }
                            this.data.push(...res.list.data)
                        } else {
                            if(!res.list.data.length && page > 1){
                                this.getList(page - 1)
                            }else{
                                this.data = res.list.data
                            }
                        }
                        this.$emit('requestEnd',res.list.data)
                    } else {
                        res.list.forEach(item => {
                            item.key = item[this.selectKey]
                        })
                        if (this.defaultExpandAllRows) {
                            this.handlerFun(res.list)
                        }
                        this.data = res.list
                        this.$emit('requestEnd',res.list)
                    }
                    //统计数据
                    if(res.list_count){
                        this.data_count = res.list_count
                    }
                    
                    this.loading = false

                }).catch(() => {
                    this.loading = false
                }).finally(() => {
                })
            },
            //分页变化
            paginchange(e, filters, sort) {
                this.pageInfo.pageSize = e.pageSize
                if (sort && sort.column ?.sorter) {
                    this.where[sort.column.sort] = sort.order == 'ascend' ? 'asc' : 'desc'
                    this.getList(e.current)
                } else {
                    this.where = {}
                    this.getList(e.current)
                }
            },
            // 搜索
            searchList(page = 1) {
                this.$nextTick(() => {
                    this.getList(page)
                })
            },
            // 当前页刷新
            pageList() {
                this.$nextTick(() => {
                    this.getList(this.pageInfo.current)
                })
            },
            //表格选择
            selectChange(selectedRowKeys, selectedRows) {
                if (this.maxNum > -1) {
                    if (selectedRowKeys.length > this.maxNum) {
                        return this.$methods.message('warning', `批量选择数量不能超过${this.maxNum}条`)
                    } else {
                        this.selectedRowKeys = selectedRowKeys
                        this.selectedRows = selectedRows
                        this.$emit('selectRow', {
                            ids: selectedRowKeys,
                            data: selectedRows
                        })
                    }
                } else {
                    this.selectedRowKeys = selectedRowKeys
                    this.selectedRows = selectedRows
                    this.$emit('selectRow', {
                        ids: selectedRowKeys,
                        data: selectedRows
                    })
                }
            },
            // 操作
            handleChange(e) {
                if (!e) {
                    return false
                }
                this.$emit('handleChange', {
                    value: e,
                    ids: this.selectedRowKeys,
                    data: this.selectedRows
                })
            },
            //获取序号
            getSerialNum(index) {
                return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
            },
            handleScroll() {
                if (this.loading) {
                    return false
                }
                const tableContainer = document.querySelector('.' + this.class).querySelector('.ant-table-body');
                const scrollPosition = tableContainer.scrollTop;
                if (scrollPosition > this.lastScrollTop) {
                    const isTop = scrollPosition === 0;
                    const isBottom = tableContainer.scrollHeight - scrollPosition === tableContainer.clientHeight;
                    if (isBottom) {
                        console.log('加载更多');
                        this.pageInfo.current++
                        this.getList(this.pageInfo.current)
                    }
                }
            },
            allChange(e) {
                this.$emit('allChange', e.target.checked)
            },
            getPopupContainer() {
                return document.querySelector('.content_main')
            }
        }
    }
</script>

<style lang="less" scoped>
    // :deep(.ant-table-cell) {
    //     padding-left: 20px !important;
    //     padding-right: 20px !important;
    // }

    .table-list {
        position: relative;
        // padding-top: 10px;
    }

    .zw_more {
        height: 50px;
    }

    .more_oper {
        position: absolute;
        left: 0;
        bottom: 5px;
        display: flex;
        align-items: center;
        min-height: 32px;

        .check_box_a {
            padding-left: 8px;
        }

        .select_num {
            margin-left: 20px;

            span {
                color: @color;
            }
        }
    }

    .more_bottom {
        bottom: 0 !important;
    }

    :deep(.ant-pagination) {
        margin-bottom: 0;
        margin-top: 20px;
    }

    .c_m_b_btn_right {
        .menu_img {
            margin-right: 10px;
            width: 25px;
            height: 25px;
            cursor: pointer;
            margin-left: 10px;
        }
    }

    .menu_box_columns {
        background: #fff;
        padding: 5px 0;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
        .m_b_c_overflow{
            max-height: 250px;
            overflow-y: scroll;
        }
        .m_b_c_box {
            cursor: pointer;
            padding: 5px;
            width: 100%;
            .ant-checkbox-wrapper{
                width: 100%;
            }
            .m_b_c_b_title{
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 80px;
            }
        }
    }

    .m_b_c_overflow::-webkit-scrollbar {
        width: 3px;
        /* 设置滚动条宽度 */
    }
</style>